/* eslint-disable no-console */
export const Logger = {
  computed: {
    verbose() {
      return !!document.cookie.match(/verbose-logging=enabled/);
    }
  },

  methods: {
    logInfo(message, data) {
      if (this.verbose) {
        console.info(`[info] ${window.location.href} ${message}`, data);

        return;
      }
      console.info(`[info] ${message}`);
    },

    logError(message, e) {
      if (this.verbose) {
        console.error(`[error] ${window.location.href} ${message}`, e);

        return;
      }
      console.error(`[error] ${message}`, e);
    }
  }
};
